import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const ArrowRight24: FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M10.9395 18.0009C11.2324 18.2938 11.7071 18.2938 12 18.0009C12.2928 17.7081 12.2928 17.2333 11.9999 16.9404L7.8105 12.7517L17.2501 12.751C17.6642 12.7509 18 12.4151 18 12.001C18 11.5867 17.6642 11.2509 17.2499 11.251L7.809 11.2516L11.9999 7.06138C12.2928 6.76855 12.2928 6.29373 12 6.00088C11.7071 5.70804 11.2324 5.70804 10.9395 6.00088L4.9395 12.0009L10.9395 18.0009Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
